// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__O7JWM","navHelper":"Pagination_navHelper__VbaJ9","chevron":"Pagination_chevron__5Fcfp"};